import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";

export default function AwsS3Export() {
    let id = 1;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);

    React.useEffect(() => {
        (async function() {
            try { 
                const resView = await getView();
                setData(resView);
                setStatusChecked(resView.status===1);
                refUrl.current.value = resView.url;
                refBucket.current.value = resView.bucket;
                refFolderContentId.current.value = resView.folderContentId;
                refRegion.current.value = resView.region;
                refVersion.current.value = resView.version;
                refAccessKeyId.current.value = resView.accessKeyId;
                refSecretKey.current.value = resView.secretKey;
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/awsS3Export/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    let refUrl = React.useRef();
    let refBucket = React.useRef();
    let refFolderContentId = React.useRef();
    let refRegion = React.useRef();
    let refVersion = React.useRef();
    let refAccessKeyId = React.useRef();
    let refSecretKey = React.useRef();

    const onUpdate = () => {

        let url = refUrl.current.value;
        let bucket = refBucket.current.value;
        let folderContentId = refFolderContentId.current.value;
        let region = refRegion.current.value;
        let version = refVersion.current.value;
        let accessKeyId = refAccessKeyId.current.value;
        let secretKey = refSecretKey.current.value;

        if(!url) {
            toast.error("กรุณาระบุ S3 Url");
            refUrl.current.focus();
        }
        else if(!bucket) {
            toast.error("กรุณาระบุ Bucket");
            refBucket.current.focus();
        }
        else if(!folderContentId) {
            toast.error("กรุณาระบุ Folder ContentId");
            refFolderContentId.current.focus();
        }
        else if(!region) {
            toast.error("กรุณาระบุ Region");
            refRegion.current.focus();
        }
        else if(!version) {
            toast.error("กรุณาระบุ Version");
            refVersion.current.focus();
        }
        else if(!accessKeyId) {
            toast.error("กรุณาระบุ Access Key Id");
            refAccessKeyId.current.focus();
        }
        else if(!secretKey) {
            toast.error("กรุณาระบุ Secret Key");
            refSecretKey.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                url: url,
                                bucket: bucket,
                                folderContentId: folderContentId,
                                region: region,
                                version: version,
                                accessKeyId: accessKeyId,
                                secretKey: secretKey,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/awsS3Export/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> AWS S3</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="url" className="form-label">S3 URL <span className="text-danger">*</span></label>
                                <textarea className="form-control" id="url" ref={refUrl} maxLength={250} rows={3}></textarea>
                            </div>
                            <div className="col-12">
                                <label htmlFor="bucket" className="form-label">Bucket <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="bucket" ref={refBucket} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="folderContentId" className="form-label">Folder ContentId <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="folderContentId" ref={refFolderContentId} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="region" className="form-label">Region <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="region" ref={refRegion} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="version" className="form-label">Version <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="version" ref={refVersion} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="accessKeyId" className="form-label">Access Key Id <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="accessKeyId" ref={refAccessKeyId} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="secretKey" className="form-label">Secret Key <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="secretKey" ref={refSecretKey} maxLength={100} />
                            </div>

                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} disabled={!roles.isEdit(Utils.MENU_AWS_S3_EXPORT)} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            {
                                roles.isEdit(Utils.MENU_AWS_S3_EXPORT) ?
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                        <Toaster position="bottom-right" />
                                    </div> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6 d-none">
                        <div className="bg-yellow-light rounded p-2">
                            <label htmlFor="name" className="form-label">S3 Info</label>
                            <ul className="list-group">
                                <li className="list-group-item">FullName : </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
} 